import { z } from 'zod'
import { numberWithEmptySchema } from './number-with-empty'

export const applyFlightSchema = z.object({
  /** 出發地代碼 */
  depAirportCode: z.string(),
  /** 目的地代碼 */
  arrAirportCode: z.string(),
  /** 航空公司 */
  airline: z.string(),
  /** 航班號碼 */
  flightNumber: z.string(),
  /** 訂位艙等 */
  rbd: z.string(),
  /** 實際訂位艙等 */
  actualRBD: z.string(),
  /** 排序 */
  sort: numberWithEmptySchema
})

export interface ApplyFlight extends z.infer<typeof applyFlightSchema> {}

export class ApplyFlight {
  constructor() {
    return {
      depAirportCode: '',
      arrAirportCode: '',
      airline: '',
      flightNumber: '',
      rbd: '',
      actualRBD: '',
      sort: null
    }
  }
}
